module.exports = __webpack_public_path__ + "static/design-3356d4e0d16e2efe8933d37523ceffed.png";